/* Step 13: Weekend Special countdown.
 * Computes the next occurrence of dow / hour in America/Toronto and
 * counts down. Auto-resets after the deadline passes (next tick rolls
 * over to the following week).
 */
(function () {
  'use strict';

  var DAY_MAP = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  // Returns parts of `now` as observed in `tz` (a TZ database name).
  function partsIn(tz, when) {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      weekday: 'short',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    });
    var p = {};
    fmt.formatToParts(when).forEach(function (x) { p[x.type] = x.value; });
    return p;
  }

  // Given Toronto wall-clock target (Y/M/D h:m), return its UTC ms.
  // Walks the offset by probing — robust around DST transitions.
  function torontoWallToUTC(year, month, day, hour, minute) {
    // First guess: assume EDT (-4)
    var guess = Date.UTC(year, month - 1, day, hour + 4, minute, 0);
    // Verify by formatting back
    var p = partsIn('America/Toronto', new Date(guess));
    var actualH = parseInt(p.hour, 10);
    var diff = hour - actualH;
    if (diff !== 0) guess += diff * 3600000;
    return guess;
  }

  function nextDeadlineMs(dow, hour) {
    var nowParts = partsIn('America/Toronto', new Date());
    var todayDow = DAY_MAP[nowParts.weekday];
    var todayHour = parseInt(nowParts.hour, 10);
    var todayMin  = parseInt(nowParts.minute, 10);

    var daysUntil = (dow - todayDow + 7) % 7;
    if (daysUntil === 0 && (todayHour > hour || (todayHour === hour && todayMin >= 0))) {
      daysUntil = 7;
    }
    // Construct target Toronto wall date
    var year = parseInt(nowParts.year, 10);
    var month = parseInt(nowParts.month, 10);
    var day = parseInt(nowParts.day, 10);
    // Add daysUntil to wall date — JS Date math in UTC then convert
    var base = Date.UTC(year, month - 1, day + daysUntil);
    var d = new Date(base);
    return torontoWallToUTC(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate(), hour, 0);
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function readable(ms, tz) {
    try {
      return new Intl.DateTimeFormat(undefined, {
        timeZone: tz, weekday: 'long', month: 'long', day: 'numeric',
        hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
      }).format(new Date(ms));
    } catch (e) { return new Date(ms).toString(); }
  }

  function bind(root) {
    var dow = parseInt(root.dataset.deadlineDow, 10);
    var hr  = parseInt(root.dataset.deadlineHour, 10);
    var tz  = root.dataset.deadlineTz || 'America/Toronto';
    var deadlineMs = nextDeadlineMs(dow, hr);

    var d = root.querySelector('[data-ws-d]');
    var h = root.querySelector('[data-ws-h]');
    var m = root.querySelector('[data-ws-m]');
    var s = root.querySelector('[data-ws-s]');
    var rd = root.querySelector('[data-ws-deadline-readable]');
    if (rd) rd.textContent = readable(deadlineMs, tz);

    function tick() {
      var diff = deadlineMs - Date.now();
      if (diff <= 0) {
        deadlineMs = nextDeadlineMs(dow, hr);
        if (rd) rd.textContent = readable(deadlineMs, tz);
        diff = deadlineMs - Date.now();
      }
      var sec = Math.floor(diff / 1000);
      var days = Math.floor(sec / 86400); sec -= days * 86400;
      var hrs  = Math.floor(sec / 3600);  sec -= hrs * 3600;
      var mins = Math.floor(sec / 60);    sec -= mins * 60;
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hrs);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(sec);
    }
    tick();
    setInterval(tick, 1000);
  }

  function boot() { document.querySelectorAll('[data-ws]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
